import i18next from 'i18next';
import { ClinicInvoiceServiceType } from 'infrastructure/enums';

export interface IClinicInvoiceServiceTypeItem {
  id: ClinicInvoiceServiceType;
  name: string;
}

export const clinicInvoiceServiceTypesDataSource =
  (): IClinicInvoiceServiceTypeItem[] => {
    return [
      {
        id: ClinicInvoiceServiceType.RPM,
        name: i18next.t('clinicInvoiceServiceTypes.rpm'),
      },
      {
        id: ClinicInvoiceServiceType.CCM,
        name: i18next.t('clinicInvoiceServiceTypes.ccm'),
      },
      {
        id: ClinicInvoiceServiceType.COMPLEX_CCM,
        name: i18next.t('clinicInvoiceServiceTypes.complex_ccm'),
      },
      {
        id: ClinicInvoiceServiceType.BHI,
        name: i18next.t('clinicInvoiceServiceTypes.bhi'),
      },
    ];
  };
